export { default } from './LocationCard';
